import type { PageLoad } from "./$types"
import { environment } from "$lib/env"
import { DetectedCountry } from "$lib/stores"

const apiUrl = environment.apiUrl

export const load: PageLoad = async ({ fetch, url, params, data, parent }) => {
  const category = url.searchParams.get("category") || "1"
  const page = 0
  const size = 12
  const token = data.token
  let headers = {}

  // Get parent data with proper typing
  const parentData = await parent()

  // Type-safe access to countryCode
  if (parentData && "countryCode" in parentData) {
    DetectedCountry.set(parentData.countryCode as string | null)
  }

  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      // Add cache control headers to prevent caching
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      "Pragma": "no-cache"
    }
  } else {
    headers = {
      "Content-Type": "application/json",
      // Add cache control headers to prevent caching
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      "Pragma": "no-cache"
    }
  }

  try {
    // Use Promise.allSettled instead of Promise.all to handle partial failures
    const [response1Result, response2Result] = await Promise.allSettled([
      fetch(`${apiUrl}/games?page=${page}&size=${size}&gameCategorySlug=popular`, { headers }),
      fetch(`${apiUrl}/me`, { headers })
    ]);

    // Initialize with empty data structures
    let data1 = { data: [] };
    let data2 = { data: {} };

    // Process first response if successful
    if (response1Result.status === 'fulfilled' && response1Result.value.ok) {
      data1 = await response1Result.value.json();
    }

    // Process second response if successful
    if (response2Result.status === 'fulfilled' && response2Result.value.ok) {
      data2 = await response2Result.value.json();

      // If we got country code from /me endpoint, update the store
      if (data2?.data?.countryCode) {
        DetectedCountry.set(data2.data.countryCode);
      }
    }

    return {
      props: {
        data1,
        data2,
      },
    }
  } catch (error) {
    // Return empty data structures on error to prevent 500 errors
    return {
      props: {
        data1: { data: [] },
        data2: { data: {} }
      }
    }
  }
}